export default (method, test = {}, isDeleted = false) => (dispatch, getState) => {

  const { token, clientEmail, entry, analysis, wtRegion }  = getState()
  const portfolioId = analysis ? analysis[0].id : entry.original.id
  if (isDeleted) dispatch({ type: 'DELETE_STRESS_TEST', id: test.id, pending: true })

  const makeTheCall = (url, body, callback) => {
    fetch(url, {
      method,
      ...(body ? { body } : {}),
      headers: {
        'Content-Type': 'application/json',
        Authorization: token &&
          `Token ${token}`,
      }
    })
    .then(d => {
      if(d.status === 404){
        return []
      }
      return d.json()
    })
    .then(callback)
    .catch(error => {
      console.error(error);
    })
  }

  let body, callback;
  let url = process.env.REACT_APP_API_URL+'/stresstest/custom/'

  if(method === 'GET'){
    url += `find_by_email/?clientEmail=${clientEmail}&wtRegion=${wtRegion}&entityCCY=${entry.original.entityCCY}`
    callback = stressTests => {
      dispatch({ 
        type: 'LOAD_SAVED_STRESS_TESTS',
        tests: stressTests.length > 0 ? stressTests : [] 
      })
    }
  } else if(method === 'PUT') {
    url += (test.id+'/')
    body = JSON.stringify({
      ...test,
      clientEmail,
      isDeleted,
      portfolioIds: [ ...(test.portfolioIds || []), portfolioId ],
    });
    callback = data => {
      if(isDeleted) {
        dispatch({ type: 'DELETE_STRESS_TEST', id: data.id, pending: false });
      } else {
        dispatch({ type: 'SET_STRESS_TEST_SAVED', saveAll: false, id: data.id })
      }
    }
  } else if(method === 'POST') {
    url += `?wtRegion=${wtRegion}&entityCCY=${entry.original.entityCCY}`
    let tests = test.length 
      ? test.map(d => ({ 
          ...d, 
          clientEmail, 
          wtRegion, 
          entityCCY: entry.original.entityCCY, 
          portfolioIds: [ portfolioId ], 
        })) 
      : [{ ...test, clientEmail, wtRegion, entityCCY: entry.original.entityCCY, portfolioIds: [ portfolioId ], }]
    body = JSON.stringify(tests);
    callback = data => {
      dispatch({ type: 'LOAD_SAVED_STRESS_TESTS', tests: data })
      dispatch({ type: 'SET_STRESS_TEST_SAVED', saveAll: true })
      dispatch({ type: 'SELECT_CUSTOM_STRESS_TEST', index: 0 })
    };
  }

  makeTheCall(url, body, callback);

};


// WEBPACK FOOTER //
// ./src/actions/query-api/stress-test.js